import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { EmailLog } from "./type";

export default function EmailLogDetailButton(props: GridCellParams<EmailLog, any>) {
  return (
    <Link component={RouterLink} to={props.row.id.toString()}>
      Detay
    </Link>
  );
}
